import { useMediaQuery } from "@/components/gluestack/utils/use-media-query"
import React from "react"
import resolveConfig from "tailwindcss/resolveConfig"
import * as tailwindConfig from "../../tailwind.config"

const TailwindTheme = resolveConfig(tailwindConfig as any)
const mdBreakpoint = parseInt(
  TailwindTheme.theme.screens.md.replace("px", ""),
  10,
)

interface DesktopOnlyProps {
  children: React.ReactNode
}

export const DesktopOnly: React.FC<DesktopOnlyProps> = ({ children }) => {
  const [isDesktop] = useMediaQuery({ minWidth: mdBreakpoint })

  if (!isDesktop) {
    return null
  }

  return <>{children}</>
}
